// Frontend RBAC hints. The EXISTING backend remains authoritative for all
// authorization; this only controls which nav items / actions are shown.

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  management: "Management",
  qa_manager: "QA Manager",
  qa_executive: "QA Executive",
  production_manager: "Production Manager",
  production_supervisor: "Production Supervisor",
  stores_manager: "Stores Manager",
  store_executive: "Store Executive",
  purchase_manager: "Purchase Manager",
  maintenance_manager: "Maintenance Manager",
  maintenance_executive: "Maintenance Executive",
  accounts: "Accounts",
  sales: "Sales",
  auditor: "Auditor",
};

export const ALL_ROLES = Object.keys(ROLE_LABELS);

// A role can access an item if the item has no `roles` restriction, or the
// role is included. super_admin always has access.
export function canAccess(role, itemRoles) {
  if (!itemRoles || itemRoles.length === 0) return true;
  if (role === "super_admin") return true;
  return itemRoles.includes(role);
}
